
export const ADD_APPOINTMENT = "ADD_APPOINTMENT ";
export const GET_ONE_APPOINTMENT = "GET_ONE_APPOINTMENT";
export const GET_APPOINTMENTS = "GET_APPOINTMENTS";
export const DELETE_APPOINTMENT = "DELETE_APPOINTMENT";
export const UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT";
